require('../../js/bootstrap-select.min')
//require('../../js/stickybits.min')

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();

    /* $('[rel="sidebar-tooltip"]').tooltip({ 
        container: '.price-comparator' 
    }).each(function(i, el){ $(el).data('bs.tooltip').tip().addClass('sidebar-tooltip') });
    */

    //$('.compare-card').stickybits();
    

    //$('[data-toggle="tooltip"]').tooltip();
    $('.selectpicker').selectpicker();

    //init modals - nisem našel druge rešitve za bootstrap 3
    $('#calculateModal').modal();
    $('#calculateModal').modal('hide');

    $('#calculateGasModal').modal();
    $('#calculateGasModal').modal('hide');

    $('#offerDetailsModal').modal();
    $('#offerDetailsModal').modal('hide');

    $('#offerCompareModal').modal();
    $('#offerCompareModal').modal('hide');

    
    //
    // // Make monochrome colors
    // var resourcesGraphColors = (function () {
    //     var colors = ['#9ACC23', '#EE5A24', '#FFE100'],
    //         base = Highcharts.getOptions().colors[0],
    //         i;
    //
    //     for (i = 0; i < 10; i += 1) {
    //         // Start out with a darkened base color (negative brighten), and end
    //         // up with a much brighter color
    //         colors.push(Highcharts.color(base).brighten((i - 3) / 7).get());
    //     }
    //     return colors;
    // }());
    //
    // // Build the table chart (minimal)
    //
    // var minimalChart = {
    //     chart: {
    //         plotBackgroundColor: null,
    //         plotBorderWidth: null,
    //         plotShadow: false,
    //         type: 'pie',
    //         height: 34,
    //         width: 34,
    //         marginLeft: 0,
    //         marginRight: 0,
    //         spacingLeft: 0,
    //         spacingRight: 0,
    //         backgroundColor: 'transparent'
    //     },
    //     title: {
    //         text: '',
    //         style: {
    //             display: 'none'
    //         }
    //     },
    //     subtitle: {
    //         text: '',
    //         style: {
    //             display: 'none'
    //         }
    //     },
    //     credits: {
    //         enabled: false
    //     },
    //     exporting: {
    //         enabled: false
    //     },
    //     tooltip: {
    //         enabled: false,
    //         pointFormat: ''
    //     },
    //     accessibility: {
    //         point: {
    //             valueSuffix: '%'
    //         }
    //     },
    //     plotOptions: {
    //         pie: {
    //             allowPointSelect: false,
    //             colors: resourcesGraphColors,
    //             dataLabels: {
    //                 enabled: false
    //             },
    //             size: 30
    //         },
    //         series: {
    //             states: {
    //                 hover: {
    //                     enabled: false
    //                 }
    //             },
    //             animation: false
    //         }
    //     },
    //     xAxis:{
    //         minPadding:0,
    //         maxPadding:0
    //     },
    // };
    //
    // /* Primer za graf v tabeli */
    //
    // Highcharts.chart('resources-pie-1', {
    //     chart: minimalChart.chart,
    //     title: minimalChart.title,
    //     subtitle: minimalChart.subtitle,
    //     credits: minimalChart.credits,
    //     exporting: minimalChart.exporting,
    //     tooltip: minimalChart.tooltip,
    //     accessibility: minimalChart.accessibility,
    //     plotOptions: minimalChart.plotOptions,
    //     xAxis: minimalChart.xAxis,
    //     series: [{
    //         name: 'Delež virov',
    //         data: [
    //             { name: 'Obnovljivi viri', y: 61.41 },
    //             { name: 'Fosilni viri', y: 20.84 },
    //             { name: 'Jedrsko gorivo', y: 10.85 }
    //         ]
    //     }]
    // });
    //
    // Highcharts.chart('resources-pie-2', {
    //     chart: minimalChart.chart,
    //     title: minimalChart.title,
    //     subtitle: minimalChart.subtitle,
    //     credits: minimalChart.credits,
    //     exporting: minimalChart.exporting,
    //     tooltip: minimalChart.tooltip,
    //     accessibility: minimalChart.accessibility,
    //     plotOptions: minimalChart.plotOptions,
    //     xAxis: minimalChart.xAxis,
    //     series: [{
    //         name: 'Delež virov',
    //         data: [
    //             { name: 'Obnovljivi viri', y: 0 },
    //             { name: 'Fosilni viri', y: 90.84 },
    //             { name: 'Jedrsko gorivo', y: 10.85 }
    //         ]
    //     }]
    // });
    //
    // Highcharts.chart('resources-pie-3', {
    //     chart: minimalChart.chart,
    //     title: minimalChart.title,
    //     subtitle: minimalChart.subtitle,
    //     credits: minimalChart.credits,
    //     exporting: minimalChart.exporting,
    //     tooltip: minimalChart.tooltip,
    //     accessibility: minimalChart.accessibility,
    //     plotOptions: minimalChart.plotOptions,
    //     xAxis: minimalChart.xAxis,
    //     series: [{
    //         name: 'Delež virov',
    //         data: [
    //             { name: 'Obnovljivi viri', y: 61.41 },
    //             { name: 'Fosilni viri', y: 40.84 },
    //             { name: 'Jedrsko gorivo', y: 5.85 }
    //         ]
    //     }]
    // });
    //
    // Highcharts.chart('resources-pie-4', {
    //     chart: minimalChart.chart,
    //     title: minimalChart.title,
    //     subtitle: minimalChart.subtitle,
    //     credits: minimalChart.credits,
    //     exporting: minimalChart.exporting,
    //     tooltip: minimalChart.tooltip,
    //     accessibility: minimalChart.accessibility,
    //     plotOptions: minimalChart.plotOptions,
    //     xAxis: minimalChart.xAxis,
    //     series: [{
    //         name: 'Delež virov',
    //         data: [
    //             { name: 'Obnovljivi viri', y: 40.41 },
    //             { name: 'Fosilni viri', y: 20.84 },
    //             { name: 'Jedrsko gorivo', y: 15.85 }
    //         ]
    //     }]
    // });
    //
    // Highcharts.chart('resources-pie-5', {
    //     chart: minimalChart.chart,
    //     title: minimalChart.title,
    //     subtitle: minimalChart.subtitle,
    //     credits: minimalChart.credits,
    //     exporting: minimalChart.exporting,
    //     tooltip: minimalChart.tooltip,
    //     accessibility: minimalChart.accessibility,
    //     plotOptions: minimalChart.plotOptions,
    //     xAxis: minimalChart.xAxis,
    //     series: [{
    //         name: 'Delež virov',
    //         data: [
    //             { name: 'Obnovljivi viri', y: 61.41 },
    //             { name: 'Fosilni viri', y: 20.84 },
    //             { name: 'Jedrsko gorivo', y: 10.85 }
    //         ]
    //     }]
    // });
    //
    // //Sestava končnega zneska graf
    //
    // var priceChartColors = (function () {
    //     var colors = ['#9980FA', '#B7E2F5', '#F79F1F', '#FFE100'],
    //         base = Highcharts.getOptions().colors[0],
    //         i;
    //
    //     for (i = 0; i < 10; i += 1) {
    //         // Start out with a darkened base color (negative brighten), and end
    //         // up with a much brighter color
    //         colors.push(Highcharts.color(base).brighten((i - 3) / 7).get());
    //     }
    //     return colors;
    // }());
    //
    // Highcharts.chart('price-chart', {
    //     chart: {
    //         renderTo: 'chart',
    //         type: 'pie',
    //         backgroundColor: 'transparent'
    //     },
    //     credits: {
    //         enabled: false
    //     },
    //     exporting: {
    //         enabled: false
    //     },
    //     title:{
    //         text:''
    //     },
    //     plotOptions: {
    //         series: {
    //             pointPadding: 0.1,
    //             groupPadding: 0,
    //             borderWidth: 0,
    //             shadow: false
    //         },
    //         pie: {
    //             shadow: false,
    //             borderWidth: 0,
    //             colors: priceChartColors,
    //             point: {
    //                 events: {
    //                     legendItemClick: function(){
    //                         this.slice(null);
    //                         return false;
    //                     }
    //                 }
    //             }
    //         }
    //     },
    //     tooltip: {
    //         enabled: false,
    //         pointFormat: ''
    //     },
    //     legend: {
    //         align: 'right',
    //         layout: 'vertical',
    //         verticalAlign: 'middle',
    //         width: 295,
    //         padding: 10,
    //         symbolWidth: 15,
    //         symbolHeight: 15,
    //         symbolRadius: 0,
    //         itemStyle: {"font-size": "16px", "font-weight": "normal", "font-family": "Helvetica"},
    //         labelFormat: "{percentage:,.1f}% {name}",
    //         itemMarginTop: 5,
    //         itemMarginBottom: 5
    //     },
    //     responsive: {
    //         rules: [{
    //             condition: {
    //                 maxWidth: 450
    //             },
    //             // Make the labels less space demanding on mobile
    //             chartOptions: {
    //                 chart: {
    //                     marginTop: 30
    //                 },
    //                 legend: {
    //                     align: 'center',
    //                     verticalAlign: 'bottom',
    //                     layout: 'horizontal',
    //                     margin: 30,
    //                     navigation: {
    //                         enabled: false
    //                     }
    //                 },
    //                 series: [{
    //                     size: '100%'
    //                 }]
    //             }
    //         }]
    //     },
    //     series: [{
    //         data: [
    //             {
    //                 name: "Električna energija",
    //                 y: 37.2
    //             },
    //             {
    //                 name: "Uporaba omrežja",
    //                 y: 31.9
    //             },
    //             {
    //                 name: "Prispevki, dodatki, trošarina",
    //                 y: 12.9
    //             },
    //             {
    //                 name: "DDV",
    //                 y: 18
    //             },
    //             {
    //                 name: "Še nekaj dodatnega z dolgim tekstom... ",
    //                 y: 12.9
    //             },
    //         ],
    //         innerSize: '30%',
    //         showInLegend: true,
    //         dataLabels: {
    //             enabled: false
    //         }
    //     }]
    // })
    //
    // Highcharts.chart('resources-chart', {
    //     chart: {
    //         renderTo: 'chart',
    //         type: 'pie',
    //         backgroundColor: 'transparent'
    //     },
    //     credits: {
    //         enabled: false
    //     },
    //     exporting: {
    //         enabled: false
    //     },
    //     title:{
    //         text:''
    //     },
    //     plotOptions: {
    //         series: {
    //             pointPadding: 0.1,
    //             groupPadding: 0,
    //             borderWidth: 0,
    //             shadow: false
    //         },
    //         pie: {
    //             shadow: false,
    //             borderWidth: 0,
    //             colors: resourcesGraphColors,
    //             point: {
    //                 events: {
    //                     legendItemClick: function(){
    //                         this.slice(null);
    //                         return false;
    //                     }
    //                 }
    //             }
    //         }
    //     },
    //     tooltip: {
    //         enabled: false,
    //         pointFormat: ''
    //     },
    //     legend: {
    //         align: 'right',
    //         layout: 'vertical',
    //         verticalAlign: 'middle',
    //         width: 295,
    //         padding: 10,
    //         symbolWidth: 15,
    //         symbolHeight: 15,
    //         symbolRadius: 0,
    //         itemStyle: {"font-size": "16px", "font-weight": "normal", "font-family": "Helvetica Neue"},
    //         labelFormat: "{percentage:,.1f}% {name}",
    //         itemMarginTop: 5,
    //         itemMarginBottom: 5
    //     },
    //     responsive: {
    //         rules: [{
    //             condition: {
    //                 maxWidth: 450
    //             },
    //             // Make the labels less space demanding on mobile
    //             chartOptions: {
    //                 chart: {
    //                     marginTop: 30,
    //                     spacingTop: 60,
    //                 },
    //                 legend: {
    //                     align: 'center',
    //                     verticalAlign: 'bottom',
    //                     layout: 'horizontal',
    //                     margin: 30,
    //                     navigation: {
    //                         enabled: false
    //                     }
    //                 },
    //                 series: [{
    //                     size: 150
    //                 }],
    //                 xAxis: {
    //                     top: 50
    //                 }
    //             }
    //         }]
    //     },
    //     series: [{
    //         data: [
    //             {
    //                 name: "Fosilni viri",
    //                 y: 61.63
    //             },
    //             {
    //                 name: "Jedrsko gorivo",
    //                 y: 31.26
    //             },
    //             {
    //                 name: "Obnovljivi viri",
    //                 y: 7.11
    //             }
    //         ],
    //         size: 140,
    //         innerSize: '30%',
    //         showInLegend: true,
    //         dataLabels: {
    //             enabled: false
    //         }
    //     }],
    //     xAxis: {
    //         top: 50
    //     }
    // })

    //sestava proizvodnih virov - graf resourcesGraphColors

    /*

    Highcharts.chart('resources-chart', {
        chart: {
            renderTo: 'chart',
            type: 'pie',
            backgroundColor: 'transparent'
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        title: {
            text : 'Sestava končnega zneska',
            align: 'left'
        },
        plotOptions: {
            pie: {
                shadow: false,
                borderWidth: 0,
                spacing: 0,
                colors: resourcesGraphColors,
                point: {
                    events: {
                        legendItemClick: function(){
                            this.slice(null);
                            return false;
                        }
                    }
                }
            }
        },
        tooltip: {
            enabled: false,
            pointFormat: ''
        },
        legend: {
            align: 'right',
            layout: 'vertical',
            verticalAlign: 'middle',
            symbolWidth: 20, 
            symbolHeight: 20,
            symbolRadius: 0,
            itemStyle: {"font-size": "18px", "font-weight": "normal", "font-family": "Helvetica Neue"},
            labelFormat: "{percentage:,.1f}% {name}",
            itemMarginTop: 5,
            itemMarginBottom: 5
        },
        series: [{
            data: [
                {
                    name: "Fosilni viri",
                    y: 61.63
                },
                {
                    name: "Jedrsko gorivo",
                    y: 31.26
                },
                {
                    name: "Obnovljivi viri",
                    y: 7.11
                }
            ],
            size: '90%',
            innerSize: '30%',
            showInLegend: true,
            dataLabels: {
                enabled: false
            }
        }]
    })
    */
});

function openModal() {
    $('#myModal').modal('show');
}

module.export = {};


//////////////////
// WEBPACK FOOTER
// ./src/portlets/price_comparator/index.js
// module id = 19
// module chunks = 0